import { Star } from "lucide-react";

export function StarRating({ value = 0, size = "h-4 w-4", className = "", interactive = false, onChange }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          onClick={interactive ? () => onChange?.(n) : undefined}
          data-testid={interactive ? `star-${n}` : undefined}
          className={`${size} ${interactive ? "cursor-pointer hover:scale-110 transition-transform" : ""} ${n <= Math.round(value) ? "fill-gold text-gold" : "text-muted-foreground/40"}`}
        />
      ))}
    </span>
  );
}

export function RatingBadge({ avg, count, className = "" }) {
  if (!count) return null;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-white/95 text-slate-900 px-2.5 py-1 text-xs font-medium ${className}`} data-testid="rating-badge">
      <Star className="h-3.5 w-3.5 fill-gold text-gold" /> {avg} <span className="text-slate-500">({count})</span>
    </span>
  );
}
